import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import ScienceSection from '@/components/ScienceSection';
import ProductCatalog from '@/components/ProductCatalog';
import QualityAssurance from '@/components/QualityAssurance';
import AboutSection from '@/components/AboutSection';
import TrustSignals from '@/components/TrustSignals';
import RFQForm from '@/components/RFQForm';
import Footer from '@/components/Footer';

export default function HomePage() {
  useEffect(() => {
    // Tawk.to Live Chat Widget
    var Tawk_API = window.Tawk_API || {};
    var Tawk_LoadStart = new Date();
    var s1 = document.createElement("script");
    s1.async = true;
    s1.src = 'https://embed.tawk.to/683620d2e083e6190d7b63d4/1is9q2lru';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', 'anonymous');
    document.head.appendChild(s1);
    return () => {
      // Cleanup on unmount
      if (document.head.contains(s1)) {
        document.head.removeChild(s1);
      }
    };
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen">
      <Helmet>
        <title>Biolyn Pharmaceutical B.V. | High-Purity Peptide APIs | European B2B Supplier</title>
        <meta name="description" content="Biolyn Pharmaceutical B.V. — European supplier of 37+ high-purity peptide APIs including Semaglutide, Tirzepatide, GHK-Cu, BPC-157, and more. >99% HPLC-verified purity. B2B only." />
        <meta property="og:title" content="Biolyn Pharmaceutical B.V. | High-Purity Peptide APIs" />
        <meta property="og:description" content="European supplier of high-purity peptide APIs for pharmaceutical developers, research institutions, and cosmetic manufacturers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://biolynpharma.com" />
        <link rel="canonical" href="https://biolynpharma.com" />
      </Helmet>
      <Navbar />
      <HeroSection />
      <ScienceSection />
      <ProductCatalog />
      <QualityAssurance />
      <AboutSection />
      <TrustSignals />
      <RFQForm />
      <Footer />
    </div>
  );
}
